import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const TextboxWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  paddingLeft: "12px",
  paddingRight: "8px",
  alignItems: "start",
  lineHeight: 1,
  border: "0"
})

export const StyledFieldLabel = styled(Typography)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  border: "0",
  fontSize: "12px",
  color: "var(--grey-grey-06)",
}))

interface StyledFieldValueProps {
  numRows: number;
}

export const StyledFieldValue = styled(Typography)<StyledFieldValueProps>(({ numRows }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  border: "0",
  fontSize: "16px",
  minHeight: `${16 * numRows}px`,
  whiteSpace: "pre-line",
}))
